import { useEffect, useState } from 'react';
import { debounce } from 'lodash';

// default value is the $tablet breakpoint of 769px

const useIsScreenWidthBelow = (inputWidth: number = 769) => {
  const [isWidthLessThanOrEqual, setIsWidthLessThanOrEqual] = useState(
    checkWindowDimensions()
  );

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsWidthLessThanOrEqual(checkWindowDimensions());
    }, 100);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function checkWindowDimensions() {
    const { innerWidth: width } = window;
    return width <= inputWidth;
  }

  return isWidthLessThanOrEqual;
};

export default useIsScreenWidthBelow;
